/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（土曜日）
 * @export
 * @interface EnableOrderdaySat
 */
export interface EnableOrderdaySat {
}

/**
 * Check if a given object implements the EnableOrderdaySat interface.
 */
export function instanceOfEnableOrderdaySat(value: object): value is EnableOrderdaySat {
    return true;
}

export function EnableOrderdaySatFromJSON(json: any): EnableOrderdaySat {
    return EnableOrderdaySatFromJSONTyped(json, false);
}

export function EnableOrderdaySatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdaySat {
    return json;
}

export function EnableOrderdaySatToJSON(json: any): EnableOrderdaySat {
    return EnableOrderdaySatToJSONTyped(json, false);
}

export function EnableOrderdaySatToJSONTyped(value?: EnableOrderdaySat | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

